import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'msReadable',
})
export class MsReadablePipe implements PipeTransform {

    transform(ms: number): string {
        const totalSeconds = Math.round(ms / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        if (ms < 1000) {
            return `${ms ?? 0} ms`;
        }

        if (minutes === 0) {
            return `${seconds} ${seconds === 1 ? 'seconde' : 'seconden'}`;
        }

        if (seconds === 0) {
            return `${minutes} ${minutes === 1 ? 'minuut' : 'minuten'}`;
        }

        return `${minutes} ${minutes === 1 ? 'minuut' : 'minuten'} ${seconds} ${seconds === 1 ? 'seconde' : 'seconden'}`;
    }
}
